var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewDocuments(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "View_Documents",
    "data-name": "View Documents",
    transform: "translate(-868 -650)",
    stroke: "#ff7200"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 0,
    height: 0,
    rx: 5,
    transform: "translate(868 650)",
    fill: "#6c757d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "index",
    d: "M151.048,145.421v19.03h12.091a7.053,7.053,0,0,1-2.194-2.2l-.121-.186.158-.242a5.932,5.932,0,0,1,4.1-2.886,2.355,2.355,0,0,1,.485-.051c.032,0,.063,0,.094.006v-8.71H160.9V145.42h-9.855Zm10.535.481v3.6h3.6Zm-7.476,3.6h3.4a.34.34,0,0,1,0,.68h-3.4a.34.34,0,1,1,0-.68Zm0,2.719h8.5a.34.34,0,0,1,0,.68h-8.5a.34.34,0,1,1,0-.68Zm0,2.718h8.5a.34.34,0,0,1,0,.68h-8.5a.34.34,0,1,1,0-.68Zm0,2.719h6.116a.34.34,0,0,1,0,.68h-6.116a.34.34,0,1,1,0-.68Zm11.558,1.919a3.891,3.891,0,0,0-.458.03,1.687,1.687,0,1,0,.48-.029h-.022Zm1.952.518a2.348,2.348,0,1,1-4.185.166,6.362,6.362,0,0,0-1.794,1.8,4.5,4.5,0,0,0,8.017-.053,6.093,6.093,0,0,0-2.038-1.915Zm-13.511.282h4.418a.34.34,0,0,1,0,.68h-4.418a.34.34,0,1,1,0-.68Z",
    transform: "translate(726.856 512.507)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDocuments);
export default __webpack_public_path__ + "static/media/ViewDocuments.8fa4cfc5c0335c25522bbf8c39d102b2.svg";
export { ForwardRef as ReactComponent };